import { z } from "zod";
import { LookupListPage } from "@/pages/admin/lookups/LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { id: number; title: string; url: string; groupName: string; sortOrder: number; deleted: boolean; }
const schema = z.object({
  title: z.string().min(1).max(200),
  url: z.string().url().max(2000),
  groupName: z.string().min(1).max(60),
  sortOrder: z.number().int(),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function SystemLinksPage() {
  return <LookupListPage<Row, Form>
    title="System links"
    apiPath="/api/lookups/system-links"
    schema={schema}
    rowKey={(r) => r.id}
    columns={[
      { id: "title", header: "Title", accessor: (r) => r.title },
      { id: "url",   header: "URL",   accessor: (r) => <a href={r.url} target="_blank" rel="noreferrer" className="underline">{r.url}</a> },
      { id: "group", header: "Group", accessor: (r) => r.groupName },
      { id: "ord",   header: "Sort",  accessor: (r) => r.sortOrder, align: "right" },
    ]}
    toFormValues={(r) => ({ title: r.title, url: r.url, groupName: r.groupName, sortOrder: r.sortOrder, deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ title: "", url: "https://", groupName: "Internal", sortOrder: 100, deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="t">Title</Label><Input id="t" {...f.register("title")} /></div>
        <div><Label htmlFor="u">URL</Label><Input id="u" type="url" {...f.register("url")} /></div>
        <div><Label htmlFor="g">Group</Label><Input id="g" {...f.register("groupName")} /></div>
        <div><Label htmlFor="o">Sort order</Label><Input id="o" type="number" {...f.register("sortOrder", { valueAsNumber: true })} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
